export default __webpack_public_path__ + "static/media/Task Manager.06556b8f.png";